module.exports = __webpack_public_path__ + "static/img/bg.cd24a8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/agentLogin/bg.png
// module id = nxY5
// module chunks = 1